import { Environment } from './environment.interface';

export { Environment } from './environment.interface';

export const environment: Environment = {
  apiKey: '',
  brands: {
    calibrant: {
      baseUrl: '/',
    },
  },
  defaults: {
    brand: 'calibrant',
    locale: 'en-us',
  },
  production: false,
};
